module.exports = __webpack_public_path__ + "static/media/production_status.ee38dcd8.png";